<template>
<div class="card">
    <div class="card-header">RDC Candidate Selection</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="19"  :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                    <BaseTextInput v-model="request.selectedCandidateName"
                                    :v="$v.request.selectedCandidateName"
                                    label="Selected Candidate Full Name"
                                    tip=""
                                    slug="fullName"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseTextInput v-model="request.selectedCandidateEmail"
                                    :v="$v.request.selectedCandidateEmail"
                                    label="Selected Candidate Email"
                                    tip=""
                                    slug="emailAddress"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="comments"
                        :v="$v.comments" 
                        slug="rdcComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>
            
            <div>
                <b-button type="submit" variant="primary">Complete RDC Candidate Selection</b-button>
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                <b-button v-b-modal.modal-rdc-document variant="outline-primary">View Employee Email Template</b-button>
            </div>
        </b-form>
    </div>

    <b-modal id="modal-rdc-document" title="Employee Onboarding Email Template" size="lg">
        <b-row>
            <b-col lg="12">
                This is just a placeholder until we have the actual text that should be inserted here.
            </b-col>
        </b-row>
    </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return { 
            checklistComplete: true,
            comments: '',
            saveOnly: false,
        }
    },
     validations: {
         comments: { required: false, maxLength: maxLength(4000) },
         checklistComplete: { checked: value => value === true },
         request: { 
             selectedCandidateName: { required, maxLength: maxLength(75) },
             selectedCandidateEmail: { required, email, maxLength: maxLength(75) },
         }
     },
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = true
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.comments,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                advanceNextLifecycle: !this.saveOnly
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/rdcCandidate`, payload)
                .then(response => {                       
                this.showRootToast("RDC Candidate Selection Submitted", "updated.", "success")
                this.$emit('status-changed') 
                })                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },
    }   
}
</script>